
















import { defineComponent, ref, toRef } from '@nuxtjs/composition-api';
import Breadcrumbs from '~/modules/storyblok/components/Static/StaticBreadcrumbs.vue';

export default defineComponent({
  name: 'StaticPageHeader',
  components: { Breadcrumbs },
  props: {
    currentStory: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const story = toRef(props, 'currentStory');
    const title = toRef(props, 'title');
    const bgImage = ref(story.value.content?.heroBackground?.filename || '');
    const currentTitle = ref(title.value || story.value.content?.SEO?.title);

    return { bgImage, currentTitle };
  },
});
